import appStore from 'store';
import api from './api';
const store = {
  namespaced: true,
  state: {
    projects: [],
    totalCount: 0,
    coinTypeList: [],
    pairList: [],
    editingProject: null,
    pagination: {
      page: 1,
      size: 25
    },
    CoinSum: {}
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setSum(state, payload) {
      state.CoinSum = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    },
    setPairList(state, payload) {
      state.pairList = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    getSum({ commit }, query) {
      api.getSum(query).then(({ data }) => {
        commit('setSum', data);
      });
    },
    update(context, data) {
      return api.update(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    listAllCoin({ commit }) {
      api.getAllpair().then(({ data }) => {
        commit('setPairList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    },
    createTest(context, data) {
      return api.createTest(data);
    }
  }
};

appStore.registerModule('leverRecord', store);
